import React, { createContext, useEffect, useState } from 'react'; // eslint-disable-line no-unused-vars

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setLoggedIn] = useState(false);

  useEffect(async () => {
    try {
      const response = await fetch('/ezvk-app/api/users/me');
      const data = await response.json();
      if (data.email || data.RNR) {
        setLoggedIn(true);
      }
    } catch (error) {
      setLoggedIn(false);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
};
